import { AdminActionType } from '../Constants';
import store, { adminUserActions } from '@apply/adminStore';
import { AdminApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';
import { handleAdminSuccess, handleAdminError } from '../../../common/SharedFunctions';
import { hasPermission } from '@apply/ui';
import { RefreshEvents } from '../../../common/SharedEvents';
import { PermissionType } from '@apply/constants';

export const executeAdminAction = (itemData: { actionId: number; id: number; isLocked: boolean; isDeleted: boolean }) => {
    const { dispatch } = store;
    const adminApi = new AdminApi.AdminApi(applicationInsights);
    const refreshEvents = new RefreshEvents();

    const onViewAdminDetails = (id: number) => {
        dispatch(
            adminUserActions.setAdminUserModal({
                adminUserModal: { isOpen: true, id },
            })
        );
        return true;
    };

    const onViewAdminRoles = (id: number) => {
        dispatch(
            adminUserActions.setAdminRolesModal({
                adminRolesModal: { isOpen: true, id },
            })
        );
        return true;
    };

    const onLockAdminAccount = async (id: number, isLocked: boolean) => {
        if (!hasPermission(PermissionType.AdminUserLockUnlock)) {
            handleAdminError(new Error('Unauthorized'), 'Sorry, you are not authorized to perform this action.');
            return;
        }
        try {
            const response = await adminApi.lockAdminUser(id, !isLocked);
            if (response.statusCode != 200) {
                throw new Error('Account Lock/Unlock failed');
            }
            if (isLocked) {
                handleAdminSuccess('The account has been unlocked successfully.');
            } else {
                handleAdminSuccess('The account has been locked successfully.');
            }
            refreshEvents.dispatchRefreshEvent();
            return true;
        } catch (ex) {
            handleAdminError(ex, 'An unexpected error has occurred! Please try again.');
            return false;
        }
    };

    const onPasswordReset = async (id: number) => {
        if (!hasPermission(PermissionType.AdminUserPasswordReset)) {
            handleAdminError(new Error('Unauthorized'), 'Sorry, you are not authorized to perform this action.');
            return;
        }
        try {
            const response = await adminApi.resetAdminUserPassword(id);
            if (response.statusCode != 200) {
                throw new Error('Password reset failed');
            }
            handleAdminSuccess('A Password reset link has been requested and will be sent to the email for this account.');
            return true;
        } catch (ex) {
            handleAdminError(ex, 'An unexpected error has occurred! Please try again.');
            return false;
        }
    };

    const onDelete = async (id: number, isDeleted: boolean) => {
        if (!hasPermission(PermissionType.AdminUserDelete)) {
            handleAdminError(new Error('Unauthorized'), 'Sorry, you are not authorized to perform this action.');
            return;
        }
        try {
            const response = await adminApi.deleteAdminUser(id, !isDeleted);
            if (response.statusCode != 200) {
                throw new Error('Admin User Delete/Undelete failed');
            }
            if (isDeleted) {
                handleAdminSuccess('The account has been undeleted successfully. It will still be locked for signin.');
            } else {
                handleAdminSuccess('The account has been deleted successfully.');
            }
            refreshEvents.dispatchRefreshEvent();
            return true;
        } catch (ex) {
            handleAdminError(ex, 'An unexpected error has occurred! Please try again.');
            return false;
        }
    };

    const onNotImplemented = () => {
        alert('Not Implemented yet!');
        return false;
    };

    switch (itemData.actionId) {
        case AdminActionType.ViewAdminDetails:
            return onViewAdminDetails(itemData.id);
        case AdminActionType.ViewAdminRoles:
            return onViewAdminRoles(itemData.id);
        case AdminActionType.Lockout:
            return onLockAdminAccount(itemData.id, itemData.isLocked);
        case AdminActionType.ResetPassword:
            return onPasswordReset(itemData.id);
        case AdminActionType.Delete:
            return onDelete(itemData.id, itemData.isDeleted);
        default:
            return onNotImplemented();
    }
};
